import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_mobile-footer_desktopapp_modalsend_app_link-click';

/**
 * User sends download link sms
 */
export function trackRetailerMobileFooterDesktopappModalsendAppLinkClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
